import { SummaryTiles } from 'app/components/SummaryTiles';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { messages } from './messages';

import { CheckBoxWithLabel } from 'app/components/CheckBoxWithLabel';
import {
  CircleDotIcon,
  ConvertIcon,
  ExportIcon,
  GridExpandIcon,
  GridToggleIcon,
  PlusIcon,
  UploadIcon,
} from 'app/assets/icons';
import CustomActionButton from 'app/components/CustomActionButton';
import IconButton from 'app/components/IconButton';
import { CommonMessages } from 'locales/CommonMessage/messages';
import { CustomDatepicker } from 'app/components/CustomDatepicker';
import CustomDataGrid from 'app/components/CustomDataGrid';
import { GridColumnProps } from '@progress/kendo-react-grid';
import CommonCell from 'app/components/CustomDataGrid/cells/CommonCell';
import { historyItems, sampleGridData } from './static';
import { GridDetailComponent } from 'app/components/CustomDataGrid/rowRender';
import { StatusLabel } from 'app/components/labels';
import PieChart from 'app/components/PieChart';
import { TextField } from 'app/components/TextField';
import { SummaryTilesV2 } from 'app/components/SummaryTilesV2';
import { DiscardPopUp } from 'app/components/DiscardPopup';
import SimpleReactValidator from 'simple-react-validator';
import { DropdownOption } from 'app/components/CustomDropDown';
import { TableGridMobileCard } from 'app/components/TableGridModileCard';
import FilterMultiSelectDropdown from 'app/components/FilterMultiSelectDropDown';
import { FileInfo } from 'app/components/MultipleFileUpload';
import { convertDateToDDMMYYYY } from 'utils/common';
import CustomSortableCell from 'app/components/CustomDataGrid/headerCells/CustomSortableCell';
import { GridSortModel } from 'utils/types';
import useGridSort from 'app/hooks/useGridSort';
import { CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import ToggleViewButton from 'app/components/ToggleViewButton';
import { useDispatch } from 'react-redux';
import { useErrorHandlingSlice } from 'app/error/slice';
import CustomDateRangePicker from 'app/components/CustomDateRangePicker';
import {
  GridInnerHeaderSubWrapper,
  PageGridWrapper,
  RowRenderWrapper,
  StyledWrapperTd,
} from 'app/components/wrappers';
import HistoryList from 'app/components/HistoryList';

import { messages as dateRangeMessages } from '../../components/CustomDateRangePicker/messages';
import ExpiryAlert from 'app/components/ExpiryAlert';
import { TextAreaComponent } from 'app/components/TextArea';

type Props = {};

//example sort for grid
const initialSort: Array<GridSortModel> = [
  { sortBy: 'openDate', sortOrder: 'asc' },
  { sortBy: 'bankName', sortOrder: 'asc' },
  { sortBy: 'amount', sortOrder: 'asc' },
];
export const ComponentesPage = (props: Props) => {
  const [dateValue, setDateValue] = React.useState<Date | null>(null);
  const [value, setValue] = React.useState<string | number>();
  const simpleValidator = useRef(new SimpleReactValidator());
  const { t } = useTranslation();
  const [showFileUploadPopup, setShowFileUploadPopup] =
    React.useState<boolean>(false);

  const dispatch = useDispatch();
  const { actions } = useErrorHandlingSlice();

  const { currentSort, setCurrentSort, updateSortBy } = useGridSort(
    initialSort, //initial sort array
    initialSort[0], //initial sort value
  );

  const [selectedDropDownVaue, setSelectedDropDownVaue] = useState<
    DropdownOption | undefined
  >({ id: 1, value: 'Option 1', label: 'Option 1' });
  const [isCheckBoxChecked, setIsCheckBoxChecked] = useState(false);
  const theme = useTheme();
  const [isShowPopup, setIsShowPopup] = React.useState(false);
  // State to store an array of selected row IDs (number or string)
  const [selectedRowIds, setSelectedRowIds] = useState<(number | string)[]>([]);
  const [expandedRowId, setExpandedRowId] = useState<number | string>('');
  const [skip, setSkip] = React.useState<number>(0);
  const [gridPageNum, setGridPageNum] = useState<number | undefined>(1);

  //dateRange states
  //useState
  const [startDate, setStartDate] = React.useState<string>();
  const [startDateDefault, setStartDateDefault] = React.useState<string>();
  const [endtDate, setEndtDate] = React.useState<string>();
  const [endtDateDefault, setEndtDateDefault] = React.useState<string>();
  const [selectedRangeValue, setSelectedRangeValue] = React.useState<any>();
  const [selectedRangeValueDefault, setSelectedRangeValueDefault] =
    React.useState<any>();
  const [isCalenderVisible, setIsCalenderVisible] =
    React.useState<boolean>(false);
  const [isCustomDate, setIsCustomDate] = React.useState<boolean>(false);
  const [isSelectedMonth, setIsSelectedMonth] = React.useState<boolean>(true);

  const handleCheckBoxClick = () => {
    setIsCheckBoxChecked(!isCheckBoxChecked);
  };

  const getLookupArray = (
    enumValues: Record<string, boolean>, // Accept boolean
    lookupValues: { id: number; name: string }[],
  ) => {
    return lookupValues.filter(item => enumValues[item.name] === true);
  };

  // Mock data
  const lokkupValueEnums = {
    locations: {
      Active: true,
      Inactive: true,
      Closed: true,
    },
  };

  const lookupValues = [
    { id: 1, name: 'Active' },
    { id: 2, name: 'Inactive' },
    { id: 3, name: 'Closed' },
  ];
  const [selectedLocations, setSelectedLocations] = useState<
    { id: number; name: string }[]
  >([]);
  const handleOnSelectOrRemoveLocation = (
    selectedList: { id: number; name: string }[],
    selectedItem: { id: number; name: string },
  ) => {
    setSelectedLocations(selectedList);
  };
  const handleExpandRow = e => {
    if (expandedRowId !== e) {
      setExpandedRowId(e);
    } else {
      setExpandedRowId('');
    }
  };

  const handleCheckAll = (event: CheckboxChangeEvent) => {
    const { value } = event;
    if (Boolean(value)) {
      setSelectedRowIds(sampleGridData?.map(item => item?.id));
      return;
    }
    setSelectedRowIds([]);
  };

  // Function to handle checkbox change
  const handleCheckboxChange = (id: number | string) => {
    setSelectedRowIds(prevState => {
      if (prevState.includes(id)) {
        // If the id is already in the array, remove it
        return prevState.filter(item => item !== id);
      } else {
        // If the id is not in the array, add it
        return [...prevState, id];
      }
    });
  };
  const columns: GridColumnProps[] = [
    {
      field: '',
      title: '',
      cell: e => (
        <StyledWrapperTd
          className={e?.dataItem?.id === expandedRowId ? 'expanded-row' : ''}
        >
          <GridExpandIcon
            className="row-expanded-icon"
            onClick={() => handleExpandRow(e?.dataItem?.id)}
          />
        </StyledWrapperTd>
      ),
      width: 50,
    },
    {
      field: '',
      title: 'All',
      headerClassName: 'all-check-header-main',
      headerCell: e => (
        <span className="k-cell-inner all-check-header">
          <span className="k-link">
            <span className="k-column-title">
              All
              <CheckBoxWithLabel
                checked={selectedRowIds.length === sampleGridData.length}
                onChange={event => handleCheckAll(event)}
                type={'box-filler'}
                className="slect-row-checkbox"
              />
            </span>
          </span>
        </span>
      ),
      cell: e => (
        <StyledWrapperTd className="cell-ckeckbox-wrapper">
          <CheckBoxWithLabel
            checked={selectedRowIds?.includes(e.dataItem.id)}
            onChange={() => handleCheckboxChange(e.dataItem.id)}
            type={'box-filler'}
          />
        </StyledWrapperTd>
      ),
      width: 80,
    },
    {
      field: 'openDate',
      title: 'OPEN DATE',
      headerClassName: 'sortable-header-column',
      headerCell: e => {
        return (
          <CustomSortableCell
            e={e}
            sorted={currentSort?.sortBy === initialSort[0]?.sortBy}
            onSortClick={e => {
              updateSortBy('openDate');
              //Apply API logic
            }}
          />
        ); //custom sortable cell
      },
      cell: e => (
        <CommonCell
          value={
            e.dataItem.openDate
              ? convertDateToDDMMYYYY(e.dataItem.openDate)
              : ''
          }
        />
      ),
      width: 150,
      sortable: true,
    },
    {
      field: 'bankName',
      title: 'BANK NAME',
      headerClassName: 'sortable-header-column',
      headerCell: e => {
        return (
          <CustomSortableCell
            e={e}
            sorted={currentSort?.sortBy === initialSort[1]?.sortBy}
            onSortClick={e => {
              updateSortBy('bankName');
              //Apply API logic
            }}
          />
        ); //custom sortable cell
      },
      cell: e => <CommonCell value={e.dataItem.bankName} />,
      width: 200,
      sortable: true,
    },
    {
      field: 'amount',
      title: 'AMOUNT',
      headerClassName: 'sortable-header-column',
      headerCell: e => {
        return (
          <CustomSortableCell
            e={e}
            sorted={currentSort?.sortBy === initialSort[2]?.sortBy}
            onSortClick={e => {
              updateSortBy('amount');
              //Apply API logic
            }}
          />
        ); //custom sortable cell
      },
      cell: e => <CommonCell value={`${e.dataItem.amount} AED`} />,
      width: 150,
      sortable: true,
    },
    {
      field: 'utilizedAmount',
      title: 'UTILIZED AMOUNT',
      headerClassName: 'sortable-header-column',
      headerCell: e => {
        return <CustomSortableCell e={e} />; //custom sortable cell
      },
      cell: e => <CommonCell value={`${e.dataItem.utilizedAmount} AED`} />,
      width: 200,
      sortable: true,
    },
    {
      field: 'status',
      title: 'STATUS',
      sortable: true,
      cell: e => {
        const { status } = e.dataItem;
        const statusTheme: string =
          status === 'active'
            ? theme.statusActive
            : status === 'inactive'
            ? theme.statusInActive
            : status === 'closed'
            ? theme.statusClosed
            : '';
        return (
          <td>
            <StatusLabel className={status ?? ''}>
              <CircleDotIcon color={statusTheme} />
              {status}
            </StatusLabel>
          </td>
        );
      },
      width: 150,
    },
    {
      field: 'renewalDate',
      title: 'RENEWAL DATE',
      headerClassName: 'sortable-header-column',
      headerCell: e => {
        return <CustomSortableCell e={e} />; //custom sortable cell
      },
      cell: e => (
        <CommonCell
          value={
            e.dataItem.renewalDate
              ? convertDateToDDMMYYYY(e.dataItem.renewalDate)
              : ''
          }
        />
      ),
      width: 150,
      sortable: true,
    },
    {
      field: '',
      title: '',
      cell: e => (
        <StyledWrapperTd>
          <CustomActionButton
            buttonType={'view'}
            name={t(CommonMessages.view())}
            disabled={false}
          />
        </StyledWrapperTd>
      ),
      width: 120,
    },
  ];

  const RowRender = (trElement, props) => {
    const { id } = props.dataItem;
    return (
      <>
        <RowRenderWrapper
          {...props}
          className={`main-grid ${expandedRowId === id ? 'active-row' : ''}`}
        >
          {trElement.props.children}
        </RowRenderWrapper>
        {expandedRowId === id && (
          // Render expanded component here
          <>
            <GridDetailComponent props={props} />
          </>
        )}
      </>
    );
  };

  //pagination Go button Click
  const onPageSubmit = (skipValue: number) => {
    setSkip?.(skipValue);
  };
  //onGridPageNextPrevClick
  const handlePageChange = event => {
    const { skip, take } = event?.page;
    setSkip(skip);
    setGridPageNum(skip / take + 1);
  };

  const commonIconButtonProps = {
    borderRadius: '4px',
    height: '26px',
    fontWeight: '600',
    hoverBgColor: theme.exportBtnHoverBg,
    hoverTextColor: theme.white,
    hoverBorderColor: theme.exportBtnHoverBg,
    hoverSvgColor: theme.white,
  };

  const handleClickApply = e => {
    setIsSelectedMonth(false);
    setIsCalenderVisible(false);
    if (selectedRangeValueDefault) {
      setStartDate(startDateDefault);
      setEndtDate(endtDateDefault);
      setSelectedRangeValue(selectedRangeValueDefault);
      // handleDateRangeClickApply(e);
    }
  };
  const handleClickCancel = () => {
    // handleMonthClick();
    setIsSelectedMonth(false);
    setIsCalenderVisible(false);
    setStartDateDefault(undefined);
    setEndtDateDefault(undefined);
    setSelectedRangeValueDefault([]);
    setIsCustomDate(false);
    setStartDate(undefined);
    setEndtDate(undefined);
    setSelectedRangeValue([]);
  };

  //history item click
  const handleClickHistory = e => {
    console.log('handleClickHistory', e);
  };

  const [isOpenNotification, setIsOpenNotification] =
    React.useState<boolean>(false);
  return (
    <Wrapper>
      <CustomActionButton
        buttonType="blackHoverBtn"
        name={t(CommonMessages.closeLoan())}
        onClick={() => setIsOpenNotification(true)}
      />
      <br />
      {/* <CreateOrUpdateMasterData
        showPopup={isCloseLoanPopup}
        setIsClosePopup={setIsCloseLoanPopup}
        type="Bank"
      /> */}
      {/* {isCloseLoanPopup && (
        <CloseLoanPopup
          showPopup={isCloseLoanPopup}
          setIsCloseLoanPopup={setIsCloseLoanPopup}
        ></CloseLoanPopup>
      )} */}
      <ExpiryAlert
        renewalDate="2024-12-24T18:30:00"
        daysThreshold={15}
        label="facility"
        className="expiry-alert"
      />

      <HistoryList
        onClick={handleClickHistory}
        data={historyItems}
        title="History"
      />
      <>
        <CustomDateRangePicker
          label={t(dateRangeMessages.openDate())}
          isSelectedMonth={isSelectedMonth}
          handleClickApply={handleClickApply}
          handleClickCancel={handleClickCancel}
          startDate={startDate}
          startDateDefault={startDateDefault}
          setStartDateDefault={setStartDateDefault}
          endtDate={endtDate}
          endtDateDefault={endtDateDefault}
          setEndtDateDefault={setEndtDateDefault}
          selectedRangeValue={selectedRangeValue}
          selectedRangeValueDefault={selectedRangeValueDefault}
          setSelectedRangeValueDefault={setSelectedRangeValueDefault}
          setSelectedRangeValue={setSelectedRangeValue}
          onClearClick={handleClickCancel}
          setIsCustomDate={setIsCustomDate}
          setIsCalenderVisible={setIsCalenderVisible}
          isCalenderVisible={isCalenderVisible}
        />
      </>
      {/* grid start */}
      {/* <>
        <CustomDateRangePicker
          label="Open Date"
          isSelectedMonth={isSelectedMonth}
          handleClickApply={handleClickApply}
          handleClickCancel={handleClickCancel}
          startDate={startDate}
          startDateDefault={startDateDefault}
          setStartDateDefault={setStartDateDefault}
          endtDate={endtDate}
          endtDateDefault={endtDateDefault}
          setEndtDateDefault={setEndtDateDefault}
          selectedRangeValue={selectedRangeValue}
          selectedRangeValueDefault={selectedRangeValueDefault}
          setSelectedRangeValueDefault={setSelectedRangeValueDefault}
          setSelectedRangeValue={setSelectedRangeValue}
        />
      </> */}
      <PageGridWrapper>
        <CustomDataGrid
          columns={columns}
          data={sampleGridData}
          rowRender={RowRender}
          showPagination
          totalCount={50}
          pageSize={10}
          skip={skip}
          setSkip={setSkip}
          gridPageNum={gridPageNum}
          setGridPageNum={setGridPageNum}
          onPageChange={handlePageChange}
          onPageInputChange={e =>
            console.log('page input change', e.target.value)
          }
          onPageSubmit={onPageSubmit}
          headerChildren={
            <>
              <GridInnerHeaderSubWrapper></GridInnerHeaderSubWrapper>
              <GridInnerHeaderSubWrapper>
                <IconButton
                  label={t(CommonMessages.export())}
                  svgIcon={<ExportIcon />}
                  bgColor={theme.white}
                  borderColor={theme.viewBtnBg}
                  textColor={theme.exportBtnTextClr}
                  {...commonIconButtonProps} //common button props
                />
                <IconButton
                  label={t(CommonMessages.addFacility())}
                  svgIcon={<PlusIcon />}
                  bgColor={theme.black}
                  borderColor={theme.black}
                  textColor={theme.white}
                  {...commonIconButtonProps} //common button props
                />
              </GridInnerHeaderSubWrapper>
            </>
          }
        />
        <ToggleViewButton svgIcon={<GridToggleIcon />} />
      </PageGridWrapper>
      {/* grid end */}

      <FileIconWrapper>
        <SummaryTiles
          title={t(messages.active())}
          value={'230000'}
          type="active"
        />
        <SummaryTiles
          title={t(messages.expired())}
          value={'31000'}
          type="inactive"
        />
        <SummaryTiles
          title={t(messages.closed())}
          value={'1000000'}
          type="closed"
        />
        <SummaryTiles
          title={'Upcoming Renewals in 45 Days'}
          value={'1000000'}
          type="upcomingRenewals"
        />
        <SummaryTiles
          title={t(messages.sublimit())}
          value={'670000'}
          type="sublimit"
        />
      </FileIconWrapper>
      <FileIconWrapperV2>
        <SummaryTilesV2
          title={t(messages.active())}
          value={230000}
          type="active"
        />
        <SummaryTilesV2
          title={t(messages.expired())}
          value={31000}
          type="expired"
        />
        <SummaryTilesV2
          title={t(messages.closed())}
          value={1000000}
          type="closed"
        />
        <SummaryTilesV2
          title={'Upcoming Renewals in 45 Days'}
          value={1000000}
          type="upcomingRenewals"
        />
        <SummaryTilesV2
          title={t(messages.sublimit())}
          value={670000}
          type="sublimit"
        />
      </FileIconWrapperV2>
      <br />
      <div style={{ padding: '20px' }}>{/* <TableGridMobileCard /> */}</div>
      <DatePickerWrapper>
        <CustomDatepicker
          title="Open Date"
          validations={'required'}
          onChange={e => setDateValue(e.value)}
          value={dateValue}
          validator={simpleValidator.current}
        />
        <br />
        <TextField
          label="Amount"
          type="text"
          validations={'required'}
          value={'Option 1'}
          placeholder="Amount"
          onChange={value => {
            setValue(value.target.value);
          }}
          validator={simpleValidator.current}
          disabled
        />
        <br />

        <TextAreaComponent label="Closure Reason" disabled />
        {/* <Dropdown
          options={[]}
          // dropDownChildren={<p>hello</p>}
          // isSearchNotRequired
          // required
          required
          label="Currency"
          clearable
          onChange={handleDropDownChange}
          placeholder="AED"
          value={{ id: 3, value: 'Option 3', label: 'Option 3' }}
          onClearClick={handleClearDropDwonValue}
          disabled
          validator={simpleValidator.current}
          validations={'required'}
        /> */}
        <br />
        <FilterMultiSelectDropdown
          label="Status"
          searchText="Search"
          data={getLookupArray(lokkupValueEnums.locations, lookupValues)}
          type="filterBy"
          className="FilterMultiSelectDropdown"
          preDataList={selectedLocations}
          onSelect={handleOnSelectOrRemoveLocation}
          onRemove={handleOnSelectOrRemoveLocation}
          showSearch={false}
        />
      </DatePickerWrapper>
      <CheckBoxWithLabel
        label="click to check"
        onChange={handleCheckBoxClick}
        checked={isCheckBoxChecked}
        type={'box-filler'}
      />
      <ButtonWrapper>
        <CustomActionButton
          buttonType={'view'}
          name={t(CommonMessages.view())}
          disabled={false}
        />
        <br />
        <CustomActionButton
          buttonType={'save'}
          name={'Error toast'}
          onClick={() => {
            dispatch(
              actions.dispatchToast({
                errorTxt: `Please fill in all required fields.`,
                show: true,
                errorType: 'error',
              }),
            );

            dispatch(actions.setToastDelay(3000));
          }}
        />
        <br />
        <CustomActionButton
          buttonType={'save'}
          name={`${t(CommonMessages.save())} toast`}
          onClick={() => {
            dispatch(
              actions.dispatchToast({
                errorTxt: `Facility added successfully!`,
                show: true,
                errorType: 'success',
              }),
            );

            dispatch(actions.setToastDelay(3000));
          }}
        />
        <br />
        <CustomActionButton
          buttonType={'save'}
          name={'Warning toast'}
          onClick={() => {
            dispatch(
              actions.dispatchToast({
                errorTxt: `This change may make issue in the future!`,
                show: true,
                errorType: 'warning',
              }),
            );

            dispatch(actions.setToastDelay(3000));
          }}
        />
        <br />
        <CustomActionButton
          buttonType={'save'}
          name={'Info toast'}
          onClick={() => {
            dispatch(
              actions.dispatchToast({
                errorTxt: `This is an example for info toast.`,
                show: true,
                errorType: 'info',
              }),
            );

            dispatch(actions.setToastDelay(3000));
          }}
        />
        <br />
        <CustomActionButton
          buttonType="addSubmit"
          name={t(CommonMessages.addSubmit())}
        />
        <br />
        <CustomActionButton
          buttonType="uploadDocBlue"
          name={t(CommonMessages.uploadDocuments())}
        />
        <br />
        <CustomActionButton
          buttonType="uploadDocBlack"
          name={t(CommonMessages.uploadDocuments())}
          onClick={() => setShowFileUploadPopup(true)}
        />
        <br />
        <CustomActionButton
          buttonType="greyHoverBtn"
          name={t(CommonMessages.renewalHistory())}
        />
        <br />
        <CustomActionButton
          buttonType="blackHoverBtn"
          name={t(CommonMessages.addPayment())}
        />
        <br />
        <CustomActionButton
          buttonType="blackHoverBtn"
          name={t(CommonMessages.modify())}
        />
        <br />
        <CustomActionButton
          buttonType="delete"
          name={t(CommonMessages.delete())}
          onClick={() => setIsShowPopup(true)}
        />
        <br />
        <CustomActionButton
          buttonType="clearbtn"
          name={t(CommonMessages.clear())}
        />
        <br />
        <IconButton
          label={t(CommonMessages.export())}
          svgIcon={<ExportIcon />}
          bgColor={theme.white}
          borderColor={theme.viewBtnBg}
          borderRadius="4px"
          textColor={theme.exportBtnTextClr}
          hoverBgColor={theme.exportBtnHoverBg}
          hoverTextColor={theme.white}
          hoverBorderColor={theme.exportBtnHoverBg}
          hoverSvgColor={theme.white}
          height="26px"
          fontWeight="600"
        />
        <br />
        <IconButton
          label={t(CommonMessages.addFacility())}
          svgIcon={<PlusIcon />}
          bgColor={theme.black}
          borderColor={theme.black}
          borderRadius="4px"
          textColor={theme.white}
          hoverBgColor={theme.exportBtnHoverBg}
          hoverTextColor={theme.white}
          hoverBorderColor={theme.exportBtnHoverBg}
          hoverSvgColor={theme.white}
          height="26px"
          fontWeight="600"
        />
        <br />
        <IconButton
          label={t(CommonMessages.uploadDocuments())}
          svgIcon={<UploadIcon />}
          bgColor={theme.blackHoverBtnBg}
          borderColor={theme.UploadDocBoderClr}
          borderRadius="4px"
          textColor={theme.UploadDocBoderClr}
          hoverBgColor={theme.exportBtnHoverBg}
          hoverTextColor={theme.white}
          hoverBorderColor={theme.exportBtnHoverBg}
          hoverSvgColor={theme.white}
          height="26px"
          fontWeight="600"
        />
        <br />
        <IconButton
          label={t(CommonMessages.convert())}
          svgIcon={<ConvertIcon />}
          bgColor={theme.addSubmitBtnBG}
          borderColor={theme.addSubmitBtnBG}
          borderRadius="4px"
          textColor={theme.white}
          hoverBgColor={theme.saveBtnHoverBg}
          hoverTextColor={theme.white}
          hoverBorderColor={theme.saveBtnHoverBorderColr}
          hoverSvgColor={theme.white}
          height="26px"
          fontWeight="600"
        />
      </ButtonWrapper>
      <DatePickerWrapper>
        <CustomDatepicker
          title="Open Date"
          validations={'required'}
          onChange={e => setDateValue(e.value)}
          value={dateValue ?? new Date()}
          disabled
        />
      </DatePickerWrapper>
      <br />
      <PieChart
        title="Total Amount"
        value1={300000}
        value2={7000000}
        totalAmount={100000000000}
        colors={[theme.pieChartSliceBlueClr, theme.pieChartSliceGreyClr]} // Custom colors
        LengendLabel1="Utilize"
        LengendLabel2="Balance"
      />
      <br />
      <PieChart
        title="Total Amount"
        value1={30}
        value2={70}
        totalAmount={100000000000}
        colors={[theme.pieChartGreenClr, theme.pieChartSliceGreyClr]} // Custom colors
        LengendLabel1="Term Loan"
        LengendLabel2="Overdraft"
      />
      <DiscardPopUp
        isShowPopup={isShowPopup}
        setIsShowPopup={setIsShowPopup}
        onDiscardClickOrDelete={() => setIsShowPopup(false)}
        mainTitle="Are you Sure?"
        subTitle="This action cannot be undone."
        button1Label={'Delete'}
        isReasonField
        textAreaLabel="Closure Reason"
        isDateField
        datePickerValue={dateValue}
        DatePickerLabel="Due Date"
        onChangeDateField={e => setDateValue(e.value)}
      />
      {/* <MultipleFileUpload
        additionalFiles={multiFiles}
        files={files}
        setFiles={setFiles}
        show={showFileUploadPopup}
        setShow={setShowFileUploadPopup}
        // dropDownLookupData={dropDownLookupData}
      />
      <MobileDetailCard
        status="Expired"
        bankName="Emirates NBD"
        openDate="24-11-24"
        currency="AED"
        totalAmount={1000000000000}
        nonFundedAmount={1000000000000}
        fundedAmount={1000000000000}
        fundedAmountUtilized={1000000000000}
        nonFundedAmountUtilized={1000000000000}
        renewalDate="24-10-2025"
      />
      /> */}
    </Wrapper>
  );
};
const DatePickerWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 10px;
  padding: 18px;
  padding-top: 12px;

  @media (min-width: 300px) and (max-width: 389px) {
    grid-template-columns: 1fr;
  }
  @media (min-width: 390px) and (max-width: 480px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 769px) and (max-width: 991px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media (min-width: 992px) and (max-width: 1023px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media (min-width: 1024px) and (max-width: 1279px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media (min-width: 1280px) and (max-width: 1365px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${p => p.theme.white};
  overflow: auto;
  .FilterMultiSelectDropdown {
    width: 85px;
    .multiSelectContainer {
      /* width: 141px; */
    }
  }
`;
const FileIconWrapperV2 = styled.div`
  display: grid;
  grid-template-columns: 138px 138px 138px 138px 138px;
  gap: 10px;
  padding: 18px;
  padding-top: 12px;
  @media (min-width: 300px) and (max-width: 389px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 390px) and (max-width: 480px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;
const FileIconWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 10px;
  padding: 18px;
  padding-top: 12px;
  @media (min-width: 300px) and (max-width: 389px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 390px) and (max-width: 480px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 769px) and (max-width: 991px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 992px) and (max-width: 1023px) {
  }
  @media (min-width: 1024px) and (max-width: 1279px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media (min-width: 1280px) and (max-width: 1365px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
  @media (min-width: 1366px) and (max-width: 1439px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
  @media (min-width: 1440px) and (max-width: 1600px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
`;
const ButtonWrapper = styled.div`
  width: 300px;
  padding: 15px 0px 20px 10px;
`;
